import React, { useContext } from 'react';
import { ButtonBase, Stack, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { RiAddFill } from 'react-icons/ri';
import { newFirestoreId } from 'common/utils/newRentalUtils';
import { useTranslation } from 'services/localization';
import { CustomizerContext } from '../../CustomizerContext';
import { FormValues } from '../../types';

const AddCustomSectionButton = () => {
	const { control } = useFormContext<FormValues>();
	const { setSectionId } = useContext(CustomizerContext);
	const { t } = useTranslation();
	const { append } = useFieldArray({
		control,
		name: 'onlineLayout.about.customContent.sections',
	});

	const handleOnClick = () => {
		const id = newFirestoreId();
		append({ id });
		setSectionId(id);
	};

	return (
		<ButtonBase onClick={handleOnClick} sx={{ width: '100%' }}>
			<Stack
				direction="row"
				spacing={1}
				alignItems="center"
				justifyContent="center"
				sx={{
					background: (theme) => theme.palette.grey['100'],
					width: '100%',
					p: 1,
				}}
			>
				<Typography color="primary">
					<RiAddFill size={16} />
				</Typography>

				<Typography
					variant="body2"
					sx={{ textTransform: 'uppercase', fontWeight: 600 }}
					color="primary"
				>
					{t('common:actions.addSection', 'Add section')}
				</Typography>
			</Stack>
		</ButtonBase>
	);
};

export default AddCustomSectionButton;
